import { UserService } from '@app/user/service/user.service';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { SystemLanguage } from '@app/user';
import { DropdownItem } from '@app/shared/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, tap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { SubtitlesService } from '../../services/subtitles.service';

@Component({
    selector: 'app-upload-subtitles-language',
    templateUrl: './subtitles-language.component.html',
    styleUrls: ['./subtitles-language.component.scss'],
    standalone: false
})
export class UploadSubtitlesLanguageComponent implements OnInit, OnDestroy {
    @Input() languageControl: FormControl<SystemLanguage>;
    @Input() subtitlesStatusControl: FormControl<number | null>;
    @Input() subtitlesEnabledControl: FormControl<boolean>;
    private userService = inject(UserService);
    private translateService = inject(TranslateService);
    private subtitlesService = inject(SubtitlesService);

    languagesItems: {
        id: SystemLanguage;
        name: string;
    }[] = [];

    readonly placeholder: DropdownItem = {
        id: '',
        name: this.translateService.instant('v3-subtitles-uploader-language-placeholder'),
        icon: '',
    };

    private readonly subscriptions = new Subscription();

    ngOnInit(): void {
        this.subscriptions.add(
            this.subtitlesService.choosenLangs$
                .pipe(
                    tap((langs) => {
                        const filteredLangs = this.userService.user.company.enabledLanguages.filter((lang) => !langs.includes(lang));

                        if (this.languageControl.value) {
                            filteredLangs.push(this.languageControl.value);
                        }
                        this.setLanguagesItems(filteredLangs);
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get isDisabled() {
        return (
            (this.subtitlesStatusControl && this.subtitlesStatusControl.value === 0) ||
            (this.subtitlesEnabledControl ? !this.subtitlesEnabledControl.value : false)
        );
    }

    private getLanguageName(langKey: SystemLanguage) {
        return this.translateService.instant(`subtitles-lang-select-${langKey}`);
    }

    private setLanguagesItems(langs: SystemLanguage[]) {
        let enLang = null;
        this.languagesItems = [];

        this.languagesItems = langs
            .map((lang) => {
                if (lang === 'en') {
                    enLang = { id: lang, name: this.getLanguageName(lang) };
                }
                return { id: lang, name: this.getLanguageName(lang) };
            })
            .filter((lang) => lang.id !== 'en')
            .sort((language1, language2) => {
                if (language1.name.toLowerCase() < language2.name.toLowerCase()) {
                    return -1;
                }
                if (language1.name.toLowerCase() > language2.name.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        if (enLang !== null) this.languagesItems.unshift(enLang);
    }
}
